"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _prizes = require("@/api/prizes");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _index = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
require("tinymce/tinymce");
require("tinymce/themes/silver");
require("tinymce/icons/default");
require("tinymce/skins/ui/oxide/skin.css");
var _tinymceVue = _interopRequireDefault(require("@tinymce/tinymce-vue"));
require("tinymce/plugins/lists");
require("tinymce/plugins/link");
require("tinymce/plugins/image");
require("tinymce/plugins/paste");
require("tinymce/plugins/help");
require("tinymce/plugins/wordcount");
require("tinymce/plugins/preview");
require("tinymce/plugins/table");
require("tinymce/plugins/code");
var _gameLevels = require("@/api/game-levels");
var _utils = require("@/utils");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.images = [];
    this.formData = Object.assign({}, _prizes.defaultPrizeData);
    this.loading = false;
    this.gameLevelsList = [];
    this.rules = {
      name: [{
        required: true,
        message: 'Please enter name',
        trigger: 'blur'
      }],
      gameLevelId: [{
        required: true,
        message: 'Please enter game level ID',
        trigger: 'blur'
      }],
      rewardPoint: [{
        required: true,
        message: 'Please enter reward point',
        trigger: 'blur'
      }],
      quantity: [{
        required: true,
        message: 'Please enter quantity',
        trigger: 'blur'
      }],
      description: [{
        required: true,
        message: 'Please enter description',
        trigger: 'blur'
      }],
      specification: [{
        required: true,
        message: 'Please enter specification',
        trigger: 'blur'
      }],
      wishListCount: [{
        required: true,
        message: 'Please enter wish list count',
        trigger: 'blur'
      }],
      claimedCount: [{
        required: true,
        message: 'Please enter claimed count',
        trigger: 'blur'
      }],
      priority: [{
        required: true,
        message: 'Please enter priority',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, _prizes.defaultPrizeData);
    }
    this.fetchGameLevels();
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await (0, _prizes.getPrizeById)(id);
      this.formData = data;
      if (this.formData.images) {
        this.images = this.formData.images.map(image => ({
          name: this.formData.name,
          url: image
        }));
      }
      const title = 'Edit Prize';
      this.setTagsViewTitle(title);
      this.setPageTitle(title);
    } catch (error) {
      this.$message.error(error.message || error);
    }
  }
  async fetchGameLevels() {
    try {
      const response = await (0, _gameLevels.getGameLevels)((0, _utils.getQuery)({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      })); // Assuming getGameLevels is an API call to fetch game levels
      this.gameLevelsList = response.data;
    } catch (error) {
      this.$message.error(error.message || 'Failed to fetch game levels');
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title} - ${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  fileUploaded(file) {
    this.formData.images.push(file.response);
  }
  fileRemoved(file) {
    console.log('fileRemoved', file);
    const index = this.formData.images.findIndex(image => image === file.url);
    if (index !== -1) {
      this.formData.images.splice(index, 1);
    }
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        await (0, _prizes.updatePrize)(this.formData.id, this.formData);
      } else {
        await (0, _prizes.createPrize)(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'Prize saved successfully',
        type: 'success',
        duration: 2000
      });
      _router.default.push('/prizes/list');
    } catch (error) {
      this.loading = false;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'PrizeDetail',
  components: {
    Editor: _tinymceVue.default,
    FileUpload: _index.default
  }
})], default_1);
var _default = exports.default = default_1;